import { useState } from "react";
import styles from "./Styles/Patient.module.css";
import moment from "moment";
import { Input, DatePicker } from "antd";
import FileUpload from "../UploadFileNewComponent/UploadFile";
import Text from "../../common/typography/text";

export default function Patient({
  formData,
  setFormData,
  // uploadedFiles = [],
  // setUploadedFiles,
}) {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

 const handleValidationChange = (e) => {
  const { name, value } = e.target;
  let newValue = value;

  if (value) {
    if (name === "patientPhone") {
      // Phone formatting: (123) 456-7890
      const digits = value.replace(/\D/g, "");
      if (digits.length <= 3) {
        newValue = `(${digits}`;
      } else if (digits.length <= 6) {
        newValue = `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
      } else {
        newValue = `(${digits.slice(0, 3)}) ${digits.slice(
          3,
          6
        )}-${digits.slice(6, 10)}`;
      }
    } else if (name === "patientEmail") {
      // Email validation:
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(value)) {
        newValue = value;
      }
    }
  }

  setFormData((prev) => ({
    ...prev,
    [name]: newValue,
  }));
};


  return (
    <div className={styles.patientSection}>
      <div className={styles.sectionHeader}>
        <span>PATIENT DETAILS</span>
      </div>

      <div className={styles.sectionBody}>
        {/* First/Last/DOB */}
        <div className={styles.row1}>
          <div className={styles.field}>
            <label className="form-label">
              First Name <span style={{ color: "red" }}>*</span>
            </label>
            <Input
              className={styles.input}
              name="patientFirstName"
              value={formData.patientFirstName || ""}
              onChange={(e) =>
                setFormData({ ...formData, patientFirstName: e.target.value })
              }
              placeholder="Enter first name"
            />
          </div>

          <div className={styles.field}>
            <label className="form-label">
              Last Name <span style={{ color: "red" }}>*</span>
            </label>
            <Input
              className={styles.input}
              name="patientLastName"
              value={formData.patientLastName || ""}
              onChange={(e) =>
                setFormData({ ...formData, patientLastName: e.target.value })
              }
              placeholder="Enter last name"
            />
          </div>

          <div className={styles.field}>
            <label className="form-label">
              Patient DOB <span style={{ color: "red" }}>*</span>
            </label>
            <DatePicker
              format="MM-DD-YYYY"
              className={styles.input}
              value={
                formData.patientDOB
                  ? moment(formData.patientDOB, "MM-DD-YYYY")
                  : null
              }
              onChange={(date, dateString) =>
                setFormData({ ...formData, patientDOB: dateString })
              }
              style={{ width: "100%" }}
            />
            <Text variant="tinyText" color="lightText">MM-DD-YYYY</Text>
          </div>
        </div>

        {/* Phone / Email */}
        <div className={styles.row2}>
          <div className={styles.field}>
            <label className="form-label">
              <span>Phone</span>
            </label>
            <Input
              className={styles.input}
              name="patientPhone"
              value={formData.patientPhone || ""}
              onChange={handleValidationChange}
              maxLength={14} // (123) 456-7890
              placeholder="(123) 456-7890"
            />
          </div>

          <div className={styles.field}>
            <label className="form-label">
              <span>Email</span>
            </label>
            <Input
              className={styles.input}
              name="patientEmail"
              value={formData.patientEmail || ""}
              onChange={handleValidationChange}
              placeholder="email@example.com"
            />
          </div>
        </div>

        {/* Address Fields */}
        <div className={styles.row2}>
          <div className={styles.field}>
            <label className={styles.label}>Address Line 1</label>
            <Input
              className={styles.input}
              name="patientAddress1"
              value={formData.patientAddress1 || ""}
              onChange={handleChange}
            />
          </div>

          <div className={styles.field}>
            <label className={styles.label}>Address Line 2</label>
            <Input
              className={styles.input}
              name="patientAddress2"
              value={formData.patientAddress2 || ""}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* City/State/ZIP */}
        <div className={styles.row3}>
          <div className={styles.cityField}>
            <label className={styles.label}>City</label>
            <Input
              className={styles.input}
              placeholder="Enter City"
              name="patientCity"
              value={formData.patientCity || ""}
              onChange={handleChange}
            />
          </div>

          <div className={styles.stateField}>
            <label className={styles.label}>State</label>
            <Input
              className={styles.input}
              placeholder="Enter State"
              name="patientState"
              value={formData.patientState || ""}
              onChange={handleChange}
            />
          </div>

          <div className={styles.zipField}>
            <label className={styles.label}>ZIP</label>
            <Input
              className={styles.input}
              placeholder="Enter ZIP"
              name="patientZip"
              value={formData.patientZip || ""}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Contact Permission */}
        <div className={styles.ContactField}>
          <label className={styles.label}>Okay to Contact Patient</label>
          <div className={styles.radioGroup}>
            <label className={styles.radioLabel}>
              <input
                type="radio"
                name="patientOkayToContact"
                checked={formData.patientOkayToContact === "yes"}
                onChange={() =>
                  setFormData({ ...formData, patientOkayToContact: "yes" })
                }
              />
              <span className={styles.radioCustom}></span>
              Yes
            </label>
            <label className={styles.radioLabel}>
              <input
                type="radio"
                name="patientOkayToContact"
                checked={formData.patientOkayToContact === "no"}
                onChange={() =>
                  setFormData({ ...formData, patientOkayToContact: "no" })
                }
              />
              <span className={styles.radioCustom}></span>
              No
            </label>
          </div>
        </div>

        {/* Patient Demo Sheets */}
        <FileUpload
          label="Patient Demo Sheets"
          uploadedFiles={uploadedFiles}
          setUploadedFiles={(files) => {
            console.log("Patient Demo Sheets files: ", files);
            setUploadedFiles(files);
            setFormData({ ...formData, patientDemoSheetsFiles: files });
          }}
          multiple={false}
        />
      </div>
    </div>
  );
}
